import queue from './queue';
import handle from './handle';

export default [queue,handle];
